import {group, persistent, requiresReload, title} from '@wix/debug-panel';

export class Settings {
  @group('Pseudo Localization')
  @title('Enabled')
  @requiresReload
  @persistent
  enablePseudoLocalization: boolean = false;

  @group('Pseudo Localization')
  @title('Multiplier')
  @requiresReload
  @persistent
  pseudoLocalizationMultiplier: number = 2;

  @group('Pseudo Localization')
  @title('Enable Uglify')
  @requiresReload
  @persistent
  enableLocalizationUglify: boolean = true;

  @title('Enable Smartling')
  @requiresReload
  @persistent
  enableSmartling: boolean = false;
}
